const state = {
  dialogVisible: false,
  componentProps: {}
}

const getters = {
  dialogVisible: state => state.dialogVisible,
  componentProps: state => state.componentProps
}

const mutations = {
  setDialogVisible (state, val) {
    state.dialogVisible = val;
  },
  setComponentProps (state, data) {
    state.componentProps = data;
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/vipPaying.js